export const product_price = "price_1OtmxtDNZni9rE7Fx6yUcPy6";
// export const product_price = "price_1OtO6JDNZni9rE7F1TAJLl5G";

export const enter_details_path = "/";
export const checkout_path = "/payment-checkout-workshop";
export const payment_success_path = "success.html";
export const payment_cancel_path = "canceled.html";
